import {
  GET_ALL_DEPARTMENT_LIST_REQUEST,
  GET_ALL_DEPARTMENT_LIST_SUCCESS,
  GET_ALL_DEPARTMENT_LIST_FAILURE,
  POST_DEPARTMENT_REQUEST,
  POST_DEPARTMENT_SUCCESS,
  POST_DEPARTMENT_FAILURE,
  PUT_DEPARTMENT_REQUEST,
  PUT_DEPARTMENT_SUCCESS,
  PUT_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE,

  GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST,
  GET_ALL_DEPARTMENT_CATEGORY_LIST_SUCCESS,
  GET_ALL_DEPARTMENT_CATEGORY_LIST_FAILURE,
  POST_DEPARTMENT_CATEGORY_REQUEST,
  POST_DEPARTMENT_CATEGORY_SUCCESS,
  POST_DEPARTMENT_CATEGORY_FAILURE,
  PUT_DEPARTMENT_CATEGORY_REQUEST,
  PUT_DEPARTMENT_CATEGORY_SUCCESS,
  PUT_DEPARTMENT_CATEGORY_FAILURE,
  DELETE_DEPARTMENT_CATEGORY_REQUEST,
  DELETE_DEPARTMENT_CATEGORY_SUCCESS,
  DELETE_DEPARTMENT_CATEGORY_FAILURE,

  GET_ALL_DEPARTMENT_INVENTORY_LIST_REQUEST,
  GET_ALL_DEPARTMENT_INVENTORY_LIST_SUCCESS,
  GET_ALL_DEPARTMENT_INVENTORY_LIST_FAILURE,
  POST_DEPARTMENT_INVENTORY_REQUEST,
  POST_DEPARTMENT_INVENTORY_SUCCESS,
  POST_DEPARTMENT_INVENTORY_FAILURE,
  PUT_DEPARTMENT_INVENTORY_REQUEST,
  PUT_DEPARTMENT_INVENTORY_SUCCESS,
  PUT_DEPARTMENT_INVENTORY_FAILURE,
  DELETE_DEPARTMENT_INVENTORY_REQUEST,
  DELETE_DEPARTMENT_INVENTORY_SUCCESS,
  DELETE_DEPARTMENT_INVENTORY_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  loading: false,
  error: null,
  departmentList: {},
  addDepartment: {},
  deleteList: {},
  updateDepartment: {},
  departmentCategoryList: {},
  addDepartmentCategory: {},
  deleteDepartmentCategory: {},
  updateDepartmentCategory: {},

  departmentInventoryList: {},
  addDepartmentInventory: {},
  deleteDepartmentInventory: {},
  updateDepartmentInventory: {},
};

export const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_DEPARTMENT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        departmentList: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_DEPARTMENT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case POST_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_DEPARTMENT_SUCCESS:
      return {
        ...state,
        addDepartment: action.payload,
        loading: false,
        error: null,
      };
    case POST_DEPARTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case PUT_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PUT_DEPARTMENT_SUCCESS:
      return {
        ...state,
        updateDepartment: action.payload,
        loading: false,
        error: null,
      };
    case PUT_DEPARTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        deleteDepartment: action.payload,
        loading: false,
        error: null,
      };
    case DELETE_DEPARTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    case GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_DEPARTMENT_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        departmentCategoryList: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_DEPARTMENT_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case POST_DEPARTMENT_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_DEPARTMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        addDepartmentCategory: action.payload,
        loading: false,
        error: null,
      };
    case POST_DEPARTMENT_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case PUT_DEPARTMENT_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PUT_DEPARTMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        updateDepartmentCategory: action.payload,
        loading: false,
        error: null,
      };
    case PUT_DEPARTMENT_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_DEPARTMENT_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_DEPARTMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        deleteDepartmentCategory: action.payload,
        loading: false,
        error: null,
      };
    case DELETE_DEPARTMENT_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_ALL_DEPARTMENT_INVENTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_DEPARTMENT_INVENTORY_LIST_SUCCESS:
      return {
        ...state,
        departmentInventoryList: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_DEPARTMENT_INVENTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case POST_DEPARTMENT_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_DEPARTMENT_INVENTORY_SUCCESS:
      return {
        ...state,
        addDepartmentInventory: action.payload,
        loading: false,
        error: null,
      };
    case POST_DEPARTMENT_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case PUT_DEPARTMENT_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PUT_DEPARTMENT_INVENTORY_SUCCESS:
      return {
        ...state,
        updateDepartmentInventory: action.payload,
        loading: false,
        error: null,
      };
    case PUT_DEPARTMENT_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_DEPARTMENT_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_DEPARTMENT_INVENTORY_SUCCESS:
      return {
        ...state,
        deleteDepartmentInventory: action.payload,
        loading: false,
        error: null,
      };
    case DELETE_DEPARTMENT_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
